// Node.JS用の型定義ファイルが組み込まれているため、ブラウザでの型定義と一致しないため、TypeScriptではなく、JavaScriptとして実装

/**
 * 連続発火した場合に最後のみ実行する間引き処理用関数
 * @param {*} callback
 * @param {*} interval
 * @returns
 */
export function debounce(callback, interval) {
  let timerId;
  return (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      callback(...args);
    }, interval);
  };
}
